export const TEBRA_EMAIL_SUFFIX = '@tebra.com';
export const EMAIL_LOCAL_PART_MAX_LENGTH = 64;

export function parseNameFromEmail(email: string): string | null {
  if (!email.toLowerCase().endsWith(TEBRA_EMAIL_SUFFIX)) {
    return null;
  }
  const [localPart] = email.split('@');
  const parts = localPart.split('.');
  if (parts.length !== 2 && parts.length !== 3) {
    return null;
  }
  const [firstName, midName, lastName] = parts;
  if (!firstName || (parts.length === 3 && !midName) || !parts[parts.length - 1]) {
    return null;
  }
  const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
  if (parts.length === 2) {
    return `${capitalize(firstName)} ${capitalize(parts[1])}`;
  } else {
    return `${capitalize(firstName)} ${capitalize(midName!)} ${capitalize(lastName!)}`;
  }
}
